import $ from "jquery";
import { materials } from "../2-material/materials";
import { colors } from "../constants/colors";
// import readShareParameters from "../utils/readShareParameters";

import beanieSetup from "../1-style/beanieSetup";
import chooseStyleSetup from "../1-style/chooseStyleSetup";
import addDescriptiontext from "../2-material/addDescriptionText";
import materialSwatchSetup from "../2-material/materialSwatchSetup";
import chooseHatSetup from "../3-hat-color/chooseHatSetup";
import add3dPopOver from "../4-one-of-one/add3dPopOver";
import addBottomsupPopover from "../4-one-of-one/addBottomsUpPopover";
import addChainstitchPopOver from "../4-one-of-one/addChainstitchPopOver";
import addMicroscriptPopOver from "../4-one-of-one/addMicroScriptPopOver";
import fontScriptSelectSetup from "../4-one-of-one/fontScriptSelectSetup";
import generateCanvas from "../4-one-of-one/generateCanvas";
// Import all setup functions
import initialSetup from "../4-one-of-one/initialSetup";
import microSetup from "../4-one-of-one/microSetup";
import appendRemoveForOutlineSwatches from "../5-thread-color/appendRemoveForOutlineSwatches";
import outlineSwatchSetup from "../5-thread-color/outlineSwatchSetup";
import scriptInputSetup from "../5-thread-color/scriptInputSetup";
import swatchThreadsSetup from "../5-thread-color/swatchThreadsSetup";

export function setupConfigurations(scriptInput: HTMLInputElement) {
  const defaultColor = colors.currentColor[0];
  const outlineClicked = false;

  // Initialize all configurations
  initializeBasicSetup();
  initializeCustomizationOptions(scriptInput, defaultColor, outlineClicked);
  initializePopOvers();
  initializeThreadSetup();

  // Read parameters if on hat customizer page
  if ($("body.hat-customizer").length > 0) {
    // readShareParameters();
  }
}

function initializeBasicSetup() {
  initialSetup();
  chooseHatSetup();
  materialSwatchSetup();
  chooseStyleSetup({ materials });
  addDescriptiontext();
  beanieSetup();
}

function initializeCustomizationOptions(
  scriptInput: HTMLInputElement,
  defaultColor: string,
  outlineClicked: boolean,
) {
  outlineSwatchSetup(defaultColor);
  appendRemoveForOutlineSwatches(); // Move this before canvas generation
  scriptInputSetup(scriptInput, outlineClicked);
  generateCanvas({
    color: defaultColor,
    text: scriptInput.value,
    id: "outline",
    withStroke: true,
  });
  fontScriptSelectSetup();
  microSetup();
}

function initializePopOvers() {
  add3dPopOver();
  addMicroscriptPopOver();
  addChainstitchPopOver();
  addBottomsupPopover();
}

function initializeThreadSetup() {
  swatchThreadsSetup();
}
